import { z } from 'zod';

export const cartItemSchema = z.object({
  productId: z.string().uuid(),
  variantId: z.string().uuid(),
  quantity: z.number().int().min(1).max(99),
});

export const cartValidateSchema = z.object({
  items: z.array(cartItemSchema).min(1, 'O carrinho está vazio'),
  couponCode: z.string().optional(),
});

export type CartItemInput = z.infer<typeof cartItemSchema>;
export type CartValidateInput = z.infer<typeof cartValidateSchema>;
